import Joi from 'joi';
import { ProductType } from 'constants.js';

const content = (payload) => {
  let { validatorLabels } = payload;
  return Joi.when('type', {
    is: 'SMS',
    then: Joi.string().required()
  })
  .when('type', {
    is: 'EMAIL',
    then: Joi.string().allow('')
  })
  .label(validatorLabels['content'] || 'Content');
};

const emailSubject = (payload) => {
  let { validatorLabels } = payload;
  return Joi.when('type', {
    is: 'EMAIL',
    then: Joi.string().required()
  })
  .when('type', {
    is: 'SMS',
    then: Joi.string().allow('')
  })
  .label(validatorLabels['emailSubject'] || 'Email Subject');
};

const details = (payload) => {
  let { validatorLabels } = payload;
  return {
    name: Joi.string()
      .label('Template Name')
      .min(3)
      .max(100)
      .required(),
    type: Joi.string()
      .label('Template Type')
      .required(),
    layout: Joi.when('type', {
      is: 'EMAIL',
      then: Joi.string().required()
    }).label('Template Layout'),
    // ...automationOptionsValidation
    campaignOccurrenceType: Joi.string()
      .allow('')
      .optional()
      .label('Automation'),
    promotional: Joi.boolean()
      .required()
      .label('Promotional Campaign'),
    surveyResponseTemplate: Joi.boolean()
      .required()
      .label('Survey Response Template'),
    productName: Joi.string()
      .label('Product Type')
      .required(),
    subscriberListId: Joi.when('productType', {
      is: ProductType.List,
      then: Joi.string()
        .label('Subscribers List')
        .required()
    }),
    schemaIdentifier: Joi.string()
      .label('Event Type')
      .required()
  };
};

const design = (payload) => {
  return {
    id: Joi.string(),
    emailSubject: emailSubject(payload),
    content: content(payload),
    jsonContent: Joi.any()
  }
};

export default (payload) => {
  return {
    details: details(payload),
    design: design(payload)
  }[payload.segment]
};
